<template>
  <div>
    <el-tabs value="tab_user" type="border-card" v-model="activeName">
      <el-tab-pane label="权限管理" name="tab_user">

        <el-form ref="form" :model="formQuery" size="mini">
          <el-form-item label="业务员名字：">
            <el-input v-model="formQuery.yewuyuanName"></el-input>
          </el-form-item>

          <el-form-item label="企业选择：" v-if= "Role.QiYe == user.role">
            <el-select
                v-model="formQuery.subQiyeIndexList"
                multiple
                filterable
                allow-create
                default-first-option
                placeholder="企业选择"
                :width="500">
              <el-option
                  v-for="item in subQiYeList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="handleAddYeWuYuan">添加业务员</el-button>

            <el-button type="primary" @click="handleQuery">查询</el-button>
          </el-form-item>
        </el-form>

        <el-table :data="userList" size="mini">
          <el-table-column label="用户帐号" prop="userId" width="150"/>
          <el-table-column label="用户名" prop="name" width="150"/>
          <el-table-column label="手机号/邮箱" width="200">
            <template v-slot="scope">
              <span>{{ `${scope.row.phone} ${scope.row.email}` }}</span>
            </template>
          </el-table-column>

          <el-table-column label="是否可回溯" width="100">
            <template v-slot="scope">
              <span>{{ scope.row.khs }}</span>
            </template>
          </el-table-column>

          <el-table-column label="支付方式" prop="payTypeStr" width="200"/>
          <el-table-column label="销售渠道" prop="saleChannelStr" width="200"/>

          <el-table-column label="操作" width="400">
            <template v-slot="scope">
              <el-button v-if="(scope.row.saleChannel & 2) === 2 && scope.row.role === Role.YeWuYuan"
                         style="margin-left: 10px;"
                         size="mini"
                         @click="handleShowQRCode(scope.$index, scope.row)">展示二维码
              </el-button>
              <el-button style="margin-left: 10px;"
                         size="mini"
                         @click="handleEditVisible(scope.$index, scope.row)">编辑
              </el-button>
              <el-button style="margin-left: 10px;"
                         size="mini"
                         type="danger"
                         @click="handleDelete(scope.$index, scope.row)">删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <el-pagination
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            small
            layout="prev, pager, next"
            :page-size="pageSize"
            :total="totalSize">
        </el-pagination>

      </el-tab-pane>

      <el-tab-pane label="企业代理的产品" name="tab_product">
        <el-form ref="form" :model="formQuery" size="mini">

          <el-form-item label="企业选择：" v-if= "Role.QiYe == user.role">
            <el-select
                v-model="formQuery.subQiyeIndexList"
                multiple
                filterable
                allow-create
                default-first-option
                placeholder="企业选择"
                :width="500">
              <el-option
                  v-for="item in subQiYeList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>

        <el-button type="primary" @click="handleQueryProduct">查询</el-button>
        <el-table :data="productList" size="mini">
          <el-table-column label="名字" prop="name" width="150"/>
          <el-table-column label="类型" prop="type" width="50"/>
          <el-table-column label="数量" prop="num" width="100"/>
          <el-table-column label="保司" prop="baosiName" width="100"/>
          <el-table-column label="状态" prop="state" width="80">
            <template v-slot="scope">
              <el-tag :type="getActiveStateTagInfo(scope.row.state).tag">{{ getActiveStateTagInfo(scope.row.state).label }}</el-tag>
            </template>
          </el-table-column>
        </el-table>

      </el-tab-pane>
    </el-tabs>
    <el-dialog title="业务员信息" :visible.sync="formVisible" :close-on-click-modal="false">
      <el-form ref="form" :model="form" size="mini">
        <el-form-item label="电话：">
          <el-input v-model="form.phone"
                    placeholder=""
                    size="mini"
                    :precision="0"
                    :min="0"
          ></el-input>
        </el-form-item>

        <el-form-item label="邮箱：">
          <el-input v-model="form.email"
                    placeholder=""
                    size="mini"
                    :precision="0"
                    :min="0"
          ></el-input>
        </el-form-item>

        <el-form-item v-if="form._id===''" label="密码：">
          <el-input v-model="form.password"
                    placeholder=""
                    size="mini"
                    :precision="0"
                    :min="0"
          ></el-input>
        </el-form-item>

        <el-form-item v-if="form._id===''" label="check密码：">
          <el-input v-model="form.checkpassword"
                    placeholder=""
                    size="mini"
                    :precision="0"
                    :min="0"
          ></el-input>
        </el-form-item>

        <el-form-item label="名字：">
          <el-input v-model="form.name"
                    placeholder=""
                    size="mini"
                    :precision="0"
                    :min="0"
          ></el-input>
        </el-form-item>

        <el-form-item label="支付方式：">
          <el-select
              v-model="form.payTypeList"
              multiple
              filterable
              allow-create
              default-first-option
              placeholder="选择支付方式">
            <el-option
                v-for="item in optPayType"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="销售渠道：">
          <el-select
              v-model="form.saleChannelList"
              multiple
              filterable
              allow-create
              default-first-option
              placeholder="选择销售渠道">
            <el-option
                v-for="item in optSaleChannelType"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="简介：">
          <el-input v-model="form.info"
                    type="textarea"
                    autosize
          ></el-input>
        </el-form-item>

        <el-form-item label="是否可回溯订单">
          <el-checkbox v-model="form.khs"></el-checkbox>
        </el-form-item>

        <el-form-item label="extra：">
          <vue-json-editor v-model="form.extra" :showBtns="true"></vue-json-editor>
        </el-form-item>

        <el-form-item>
          <el-upload
              class="upload-demo"
              action="https://jsonplaceholder.typicode.com/posts/"
              :on-remove="handleRemove"
              :before-upload="beforeUpload"
              :on-success="handleSuccess"
              :file-list="this.form.pic"
              list-type="picture">
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">只能上传jpg/png文件</div>
          </el-upload>
        </el-form-item>


      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="formVisible = false" @click.native.prevent="handleCancel">关闭</el-button>
        <template v-if="this.form._id==''">
          <el-button type="primary" @click.native.prevent="handleAdd">添加</el-button>
        </template>
        <template v-else>
          <el-button type="primary" @click.native.prevent="handleEdit">编辑</el-button>
        </template>
      </div>
    </el-dialog>


    <QRCode ref="qrCode"></QRCode>

  </div>
</template>

<script>
import VueJsonEditor from '@/components/VueJsonEditor';
import QRCode from '@/components/QRCode.vue';
import {
  OptsPayType,
  getActiveStateTagInfo, getOptsList, OptsSaleChannel,
} from '@/utils';
import {Role,getPayTypeDesc, getSaleChannelDesc,} from '@/utils/constants'
import {formToJSON} from "axios";

const resetForm = function () {
  return {
    _id: "",
    name: "",
    password: "",
    checkpassword: "",
    phone: "",
    email: "",
    pic: [],
    info: "",
    payTypeList: [],
    saleChannelList: [],
    khs: false,
    extra : {}
  }
}

export default {
  components: {
    VueJsonEditor,
    QRCode
  },
  data() {
    const getQiYeId = () => {
      let user = this.$store.state.user;
      return user.qiyeId
    };

    const getSubQiye = () => {
      const { user } = this.$store.state;
      const list = Array.from(new Set([user.qiyeId, ...(user.subQiYeList || [])]));

      return list.map((label, index) => ({
        value: index,
        label
      }));
    };

    return {
      user: this.$store.state.user,
      Role: Role,
      activeName: 'tab_user',
      qiyeId: getQiYeId(),
      qiye: {},
      formQuery: {
        yewuyuanName: "",
        subQiyeIndexList: [],
      },
      formVisible: false,
      currentPage: 1,
      pageSize: 20,
      totalSize: 0,
      form: resetForm(),
      userList: [],
      loading: false,
      productList: [],
      optPayType: [],
      optSaleChannelType: [],

      subQiYeList:  getSubQiye(),

      getActiveStateTagInfo,

      // 二维码新版
      dialogVisible: false,
      qrName: "", // 名字
      qrPhone: "", // 电话
      qrData: "", // 二维码内容
    };
  },
  created() {
    this.current_app = this.$store.state.app
  },
  mounted() {
    let params = {
      qiyeId: this.qiyeId,
    }
    this.$axios.post('/qiye/info/get', params).then(res => {
      this.qiye = res.qiye;
      this.optPayType = getOptsList(OptsPayType, this.qiye.payType);
      this.optSaleChannelType = getOptsList(OptsSaleChannel, this.qiye.saleChannel);
    }).catch(res => {
      this.loading = false;
    })
  },
  computed: {
    cur_app() {
      return this.$store.state.app;
    },
  },
  watch: {
    $route(to) {
      if (this.current_app === this.$store.state.app) {
        return
      }
    }
  },
  methods: {

    // 打开对话框并生成二维码
    handleShowQRCode: async function (index, row) {
      this.$axios.post('/qiye/userh5url/list', {
        userId: row.userId,
        qiyeId: row.qiyeId
      }).then(res => {
          this.logining = false;
          this.$refs.qrCode.showQRCodeList(row.name, row.phone, res);
        }).catch(res => {
          this.logining = false;
        })
    },

    handleAddYeWuYuan: function () {
      this.form = resetForm();
      this.formVisible = true;
    },

    handleEditVisible: function (index, row) {
      this.form = {
        name: row.name,
        phone: row.phone,
        email: row.email,
        info: row.info,
        pic: row.pic,
        _id: row._id,
        payType: row.payType,
        khs: row.khs,
        extra : row.extra || {},
        allPayType: row.allPayType,
        payTypeList: row.payTypeList,
        saleChannelList: row.saleChannelList,
      }
      this.formVisible = true
    },

    handleEdit: function (index, row) {
      let params = {
        _id: this.form._id,
        phone: this.form.phone,
        name: this.form.name,
        email: this.form.email,
        info: this.form.info,
        pic: this.form.pic,
        payType: _.sum(this.form.payTypeList),
        saleChannel: _.sum(this.form.saleChannelList),
        khs: this.form.khs,
        extra: this.form.extra,
      };
      // console.log(`修改：${JSON.stringify(params)}`);
      this.$axios.post('/auth/manager/edit', params).then(res => {
        this.$message.info('修改用户成功');
      }).catch(res => {
        this.loading = false;
      })
      // this.formVisible = false;
      resetForm()
    },

    handleDelete: function (index, row) {
      let params = {
        _id: row._id,
      }
      this.loading = true;
      this.$axios.post('/auth/manager/delete', params).then(res => {
        this.$message.info('删除用户成功');
      }).catch(res => {
        this.loading = false;
      })
    },

    handleAdd: function () {
      if (this.form.password !== this.form.checkpassword) {
        this.$message.error('密码输入不相同');
        return;
      }
      let user = this.$store.state.user;
      let params = {
        name: this.form.name,
        phone: this.form.phone,
        password: this.form.password,
        email: this.form.email,
        info: this.form.info,
        pic: this.form.pic,
        role: 0,
        qiyeId: user.qiyeId,
        qiyeName: user.qiyeName,
        payType: _.sum(this.form.payTypeList),
        saleChannel: _.sum(this.form.saleChannelList),
        khs: this.form.khs,
        extra: this.form.extra,
        type: 0,
      };
      this.$axios.post('/auth/manager/register', params).then(res => {
        this.$message.info('添加管理人员成功');
      }).catch(res => {
        this.loading = false;
      })
      // this.formVisible = false;
      resetForm()
    },

    query: function (offset) {

      let params = {
        limit: this.pageSize,
        subQiYeList: this.getSubQiyeList(),
        offset
      }
      console.log(`query params：${JSON.stringify(params)}`);
      this.$axios.post('/auth/user/list', params).then(res => {
        this.$message.info('查询管理员（后台管理员/企业管理员）成功');
        this.userList = res.userList;
        this.userList.forEach(item => {
          item["payTypeList"] = _.map(getOptsList(OptsPayType, item.payType), (v)=> v.value);
          item["payTypeStr"] = getPayTypeDesc(item.payType);
          item["saleChannelStr"] = getSaleChannelDesc(item.saleChannel);
          item["saleChannelList"] = _.map(getOptsList(OptsSaleChannel, item.saleChannel), (v)=> v.value);
        });
        this.totalSize = res.count;
      }).catch(res => {
        this.loading = false;
      })
    },

    handleQueryProduct: function () {
      let params = {
        productName: "",
        baosiName: "",
        qiyeId: this.qiyeId,
        subQiYeList: this.getSubQiyeList(),
        limit: 1000,
        offset: 0,
      }
      this.$axios.post('/product/list', params).then(res => {
        this.$message.info('查询商品成功');
        this.productList = res.product;
      }).catch(res => {
      })
    },

    getSubQiyeList: function () {
      var qiyeidList = [];
      for (let i = 0; i < this.formQuery.subQiyeIndexList.length; i++) {
        var index = this.formQuery.subQiyeIndexList[i];
        this.subQiYeList.forEach((item) => {
          if(item.value == index){
            qiyeidList.push(item.label);
          }
        });
      }
      return qiyeidList;
    },

    handleCurrentChange: function (val) {
      // console.log(`当前页: ${val}`);
      this.query((val - 1) * this.pageSize);
    },

    handleQuery: function (row, val) {
      this.query(0);
      this.currentPage = 1;
    },

    handleRemove(_, fileList) {
      fileList.forEach((file) => {
        this.form.pic.push({
          name: file.name,
          url: file.url.split('blob:')[1]
        })
      })
    },
    beforeUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
      }
      return isLt2M;
    },
    handleSuccess(res, file) {
      this.form.pic.push({
        name: file.name,
        url: file.url.split('blob:')[1]
      });
    },

    handleCancel: function () {
      this.formVisible = false;
      resetForm();
    },
  },

};

</script>

<style>
.user-table-expand {
  font-size: 0;
}

.user-table-expand label {
  width: 90px;
  color: #99a9bf;
}

.user-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}

.hide-expand .el-table__expand-column .el-icon {
  visibility: hidden;
}
</style>
